/* tslint:disable:max-line-length */
import React from 'react';
import classNames from 'classnames';
import { IconTypeProps } from '../types';

export const EditIcon = ({
  className,
  style,
  color = '#ADA9BB',
  onClick,
}: IconTypeProps) => {
  return (
    <svg
      className={classNames(className)}
      onClick={onClick}
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g clipPath="url(#clip0)">
        <path
          d="M14.9636 1.03674C13.5863 -0.343951 11.3466 -0.343951 9.96928 1.03674L0.812414 10.1902C0.740823 10.2618 0.696504 10.3538 0.682868 10.4527L0.00445532 15.4777C-0.0159993 15.6209 0.0351373 15.7641 0.134001 15.8629C0.219229 15.9482 0.338548 15.9993 0.457867 15.9993C0.478321 15.9993 0.498776 15.9993 0.519231 15.9959L3.54652 15.5868C3.79879 15.5527 3.97607 15.3209 3.94197 15.0686C3.90788 14.8164 3.67606 14.6391 3.42379 14.6732L0.996506 15.0004L1.47037 11.4959L5.15903 15.1845C5.24425 15.2698 5.36357 15.3209 5.48289 15.3209C5.60221 15.3209 5.72153 15.2732 5.80676 15.1845L14.9636 6.03108C15.6318 5.3629 16 4.47653 16 3.5322C16 2.58788 15.6318 1.70151 14.9636 1.03674ZM10.1466 2.16174L11.6841 3.69925L3.32834 12.055L1.79083 10.5175L10.1466 2.16174ZM5.4863 14.2095L3.98288 12.7061L12.3386 4.35039L13.842 5.85381L5.4863 14.2095ZM14.4829 5.19585L10.8045 1.51742C11.2716 1.13219 11.8545 0.920828 12.4682 0.920828C13.167 0.920828 13.8216 1.19356 14.3159 1.68447C14.8102 2.17538 15.0795 2.83334 15.0795 3.5322C15.0795 4.14925 14.8682 4.7288 14.4829 5.19585Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <path d="M0 0H16V16H0V0Z" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
